<a
    class="w-full flex flex-col items-center justify-center rounded-lg cursor hover:bg-p-content-hover-background"
    [ngClass]="{
        'bg-p-content-background': menuDrawerStateService.visible(),
        '!bg-primary-50 dark:!bg-primary': link.isActive && !menuDrawerStateService.visible(),
    }"
    routerLink="/sessions"
    routerLinkActive
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="menuDrawerStateService.close()"
    #link="routerLinkActive"
    pTooltip="My Schedule"
    tooltipPosition="top">
    @if (menuDrawerStateService.visible() || !link.isActive) {
        <fa-icon class="text-[20px] text-color" [icon]="faCalendar" />
    } @else {
        <fa-icon class="text-[20px] text-primary dark:text-white" [icon]="faCalendarSolid" />
    }
</a>
